import { cn } from '../../lib/utils';
import { Skeleton, SkeletonGroup } from '../portal';

/** One 20px text line (14px bar), matching `FieldLabel` / body copy. */
function Line({ className }: { className: string }) {
  return (
    <span className="flex h-5 items-center">
      <Skeleton className={cn('h-3.5', className)} />
    </span>
  );
}

/**
 * Mirrors the New Version form (title, 114px APK drop area, 4-row textarea)
 * while the publisher's verification status is checked.
 */
export function NewVersionFormSkeleton() {
  return (
    <SkeletonGroup label="Loading release form" className="space-y-10">
      <div className="flex flex-col gap-2">
        <Skeleton className="h-10 w-full max-w-[460px]" />
        <Line className="w-2/3" />
      </div>

      <div className="flex flex-col gap-2">
        <div className="flex flex-col">
          <Line className="w-20" />
          <Line className="w-3/5" />
        </div>
        <Skeleton className="h-[114px] w-full" rounded="lg" />
      </div>

      <div className="flex flex-col gap-2">
        <div className="flex flex-col">
          <Line className="w-24" />
          <Line className="w-1/2" />
        </div>
        <Skeleton className="h-[110px] w-full" rounded="lg" />
      </div>
    </SkeletonGroup>
  );
}
